import { apiService } from './api';
import { Item, CreateItemRequest, ItemFilters } from '../types';

export const itemService = {
  async getItems(filters: ItemFilters): Promise<Item[]> {
    const response = await apiService.get<Item[]>('/items', filters);
    return response.data;
  },

  async searchItems(org: string, query: string): Promise<Item[]> {
    const response = await apiService.get<Item[]>('/items/search', { org, q: query });
    return response.data;
  },

  async createItem(data: CreateItemRequest): Promise<Item> {
    const response = await apiService.post<Item>('/items', data);
    return response.data;
  },

  async updateItem(id: string, data: Partial<Item>): Promise<Item> {
    const response = await apiService.put<Item>(`/items/${id}`, data);
    return response.data;
  },

  async updateItemAvailability(id: string, available: boolean): Promise<Item> {
    const response = await apiService.patch<Item>(`/items/${id}/availability?available=${available}`);
    return response.data;
  },

  async deleteItem(id: string): Promise<void> {
    await apiService.delete(`/items/${id}`);
  },

  async hardDeleteItem(id: string): Promise<void> {
    await apiService.delete(`/items/${id}/hard`);
  }
};